export default "__VITE_ASSET__ff64e18b__"